// extracted by mini-css-extract-plugin
export default {"FourthPage":"FP_FourthPage__8v7zv"};